module.exports = "/_next/static/images/aburasoba-df5abb04a7d0169084c76bd9b86be9cd.jpg";